import React from 'react';
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';


const AddVideo = () => {
  const url = process.env.REACT_APP_BASE_URL;
    const navigate = useNavigate();
  const [data, setData] = useState({
    title: "",
    videoUrl: ""
  });
  
  const onChangeHandler = (e) => {
    const eName = e.target.name;
    const value = e.target.value;
    setData((data) => ({ ...data, [eName]: value }));
  };
  
  const onSubmitHandler = async (e) => {
    e.preventDefault();
   
  
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("videoUrl", data.videoUrl);
  
   
    try {
      const response = await axios.post(`${url}/api/video/add`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 50000, 
      });
  
      console.log('Response:', response);
      if (response.data.success) {
        // Reset form fields if the submission is successful
        setData({
          title: "",
          videoUrl: ""
        });

        toast.success("Video Added");
        navigate('/admin/dashboard/videos'); 
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      // console.error("Error submitting blog:", error);
      toast.error("An error occurred while submitting the video.");
    }
  };
  return (
        <div className='add'>
          <form className='flex-col' onSubmit={onSubmitHandler}>
            <div className='add-product-name flex-col'>
              <p>Video Title</p>
              <input
                onChange={onChangeHandler}
                value={data.title}
                type="text"
                name='title'
                placeholder='Type here'
              />
            </div>

            <div className='add-product-name flex-col'>
              <p>Video URL</p>
              <input
                onChange={onChangeHandler}
                value={data.videoUrl}
                type="text"
                name='videoUrl'
                placeholder='Type here'
              />
            </div>

            <button type="submit" className='add-btn'>ADD</button>
            <Link to="/admin/dashboard/blog" className='add-btn'>Back</Link>
          </form>
        </div>
  )
}

export default AddVideo